import React, { useEffect, useState } from "react";
import Button from "../../../UI/Buttons/Button";
import { GiJuggler } from "react-icons/gi";
import { FaArrowLeft } from "react-icons/fa";
import { StepsContainerStyled } from "../../../../styled/Resume";
import ExperienceCard from "../../Tools/ExperienceCard";
import { useTheme } from "../../../UI/Theme/ThemeContext";

const ExperienceInfo = (props) => {
    const {
        step,
        setStep,
        setStepData,
        workExpArray,
        handleWorkExpChange,
        handleDeleteExp,
        handleAddExp,
        workExpForwardOrBackward,
    } = props;

    const [disableFields, setDisableFields] = useState(true);
    const { themeName } = useTheme();

    const handleClickForward = (e) => {
        if (e) e.preventDefault();
        workExpForwardOrBackward("forward");
        if (!disableFields) {
            setStep(step + 1);
        }
    };
    const handleClickBackward = (e) => {
        if (e) e.preventDefault();
        workExpForwardOrBackward("backward");
        setStep(step - 1);
    };
   

    // Sync workExpArray to global stepData
    useEffect(() => {
        setStepData(prev => ({
            ...prev,
            experienceInfo: workExpArray
        }));
    }, [workExpArray, setStepData]);

    // Enable/disable button based on required fields
    useEffect(() => {
        if (!workExpArray || workExpArray.length === 0) {
            setDisableFields(true);
            return;
        }

        const isValid = workExpArray.every(exp => {
            return (
                exp.company?.trim() !== "" &&
                exp.position?.trim() !== "" &&
                exp.industry?.trim() !== "" &&
                exp.dateFrom?.trim() !== "" &&
                (exp.currently || exp.dateTo?.trim() !== "")
            );
        });

        setDisableFields(!isValid);
    }, [workExpArray]);

    return (
        <StepsContainerStyled theme={themeName}>
            <h2>Work/Voluntary Experience <span>(most recent first)</span></h2>
            <ExperienceCard
                workExpArray={workExpArray}
                handleWorkExpChange={handleWorkExpChange}
                handleDeleteExp={handleDeleteExp}
                handleAddExp={handleAddExp}
            />
            <div className={step > 1 ? 'btnS' : 'btn'}>
                <Button
                    justifycontent="start"
                    secondaryLight
                    width="100%"
                    clickHandle={handleClickBackward}
                >
                    <FaArrowLeft />
                    Previous
                </Button>
                    <div className="nextBtnWrap">
                        <Button
                            justifycontent="flex-end"
                            primary
                            width="100%"
                            clickHandle={handleClickForward}
                            disabled={disableFields}
                        >
                            Skills
                            <GiJuggler />
                        </Button>
                    </div>
            </div>
        </StepsContainerStyled>
    );
};

export default ExperienceInfo;